import * as React from 'react';
import withStyles from 'react-jss';
import { CssType,
  ThemeType} from '../../../../theming/jssTypes';
import { Modal, message, Input, Button, Checkbox } from 'src/design-system/components/atoms';
import { Row, Col } from 'antd';
import { bulkDeleteTripConsignment } from '../../../../api/trips';
import Loader from 'src/design-system/components/molecules/Loader/Loader';
import FailureArrayHandler from 'src/design-system/components/organisms/FailureArrayHandler/FailureArrayHandler';
import { bulkDeleteFailureColumns } from './masterData';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

const styles = (theme: ThemeType): CssType => ({
  addCNModal : {
    display: 'flex',
    '& label': {
      display: 'inline-block',
      border: `${theme.border.width.sm} solid ${theme.color.semantic.border.primary}`,
      padding: `${theme.spacing[1]} ${theme.spacing[3]}`,
      height: theme.spacing[8],
      borderRadius: `${theme.radius.sm} ${theme.spacing[0]} ${theme.spacing[0]} ${theme.radius.sm}`,
    },
    '& input': {
      width: '230px',
      borderRadius: `${theme.spacing[0]} ${theme.radius.sm} ${theme.radius.sm} ${theme.spacing[0]}`,
    },
    '& button': {
      marginLeft: theme.spacing[3],
      float: 'right',
    },
  },
  tableContainer: {
    flex: '1 1 0',
    overflow: 'auto',
    height: 300,
    marginTop: theme.spacing[4],
    boxShadow: theme.shadow.sm,
    '& .ant-table-tbody > tr > td, .ant-table-thead > tr > th' : {
      padding: theme.spacing[2],
    },
    '& button': {
      float: 'right',
    },
  },
});

class BulkDeleteConsignmentModal extends React.Component<any, any> {

  state: any = {
    selectedWorkerId: '',
    riderOptions: [],
    inputValue : '',
    cnList: new Set(),
    confirmLoading: false,
    failureArray: [],
    isErrorModalVisible: false,
    notes: '',
    autoOptimiseTaskSequence: this.props.tripResequenceMandatory,
  };

  handleFailureModalClose = () => {
    const { closeAllModals, handleModalClose } = this.props;
    this.setState({
      isErrorModalVisible: false,
    });
    if(closeAllModals){
      handleModalClose(false);
    }
  };

  handleDeleteSubmit = async() => {
    const { t } = this.props;
    this.setState({
      confirmLoading: true,
    });
    const { consignments, dataSource, taskType, selectedTripId } = this.props;
    if (consignments.length === 0 && dataSource.length === 0) {
      message.warning(t('No consignments to unassign'));
      this.setState({
        confirmLoading: false,
      });
      return;
    }
    const consignmentsToSend : any = [];
    consignments.map((x) => {
      const record = dataSource?.filter((record) => record.reference_number === x);
      consignmentsToSend.push({ referenceNumber:x,
                                taskType: record?.[0]?.task_type });
    });

    const { notes, autoOptimiseTaskSequence } = this.state;

    const body = {
      consignments:consignmentsToSend,
      notes,
      autoOptimiseTaskSequence,
      tripId: selectedTripId,
    };
    const response = await bulkDeleteTripConsignment(body);
    if (response.isSuccess) {
      const data = response.data.data;
      if (data && data.failureArray &&
        data.failureArray.length > 0) {
        this.setState({
          isErrorModalVisible : true,
          failureArray: data.failureArray,
        });
      } else {
        message.success(`${taskType} deleted from trip`);
        this.props.handleModalClose(true);
      }
    } else {
      message.error(response.errorMessage);
      this.props.handleModalClose(false);
    }
    this.setState({
      confirmLoading: false,
    });
  };

  render() {
    const { isVisible, classes, taskType, dataSource, t, theme } = this.props;
    const { cnList, confirmLoading, isLoading, inputValue,
      isErrorModalVisible, failureArray, notes, autoOptimiseTaskSequence } = this.state;
    if (isLoading) {
      return <Loader zIndex={100}/>;
    }
    const header = 'Unassign '+ taskType;
    return (
        <Modal
        confirmLoading = {confirmLoading}
        title= {header}
        width={330}
        visible={isVisible}
        onCancel={() => this.props.handleModalClose(false)}
        onOk={this.handleDeleteSubmit}
        destroyOnClose
        >
        <div>
          Are you sure you want to unassign {this.props.consignments?.length+' '+taskType} from trip?
        </div>
        <div style={{marginTop: theme.spacing[5]}}>
          <Row align="middle">
            <Col span = {4}>
              {t('Notes')}:
            </Col>
            <Col span = {20}>
              <Input
                placeholder={t('Enter Notes')}
                value={notes}
                onChange={(e) => {
                    e.preventDefault();
                    this.setState({
                      notes: e.target.value,
                    });
                }}
              />
            </Col>
          </Row>
          <Row style={{marginTop: theme.spacing[3]}}>
          <Col span = {20}>
            <Checkbox
              checked={this.state.autoOptimiseTaskSequence}
              onChange={(e) => this.setState({ autoOptimiseTaskSequence: e.target.checked })}
              disabled={this.props.tripResequenceMandatory}
            />
            <span style={{ paddingLeft: theme.spacing[3] }}>{t('Auto-Optimize Task Sequence')}</span>
          </Col>
        </Row>
        </div>
        { isErrorModalVisible ?
          <FailureArrayHandler
            failureArray={failureArray}
            isVisible={isErrorModalVisible}
            failureColumns={bulkDeleteFailureColumns}
            onModalClose={this.handleFailureModalClose} >
          </FailureArrayHandler> : null
        }
        </Modal>
    );
  }
}

const mapStateToProps = ({masterData}) => {
  return {
    tripResequenceMandatory: masterData.ops_dashboard_config?.parts_to_show
      ?.flm_trip_config?.mandatory_resequence_trip || false,
  };
};

export default withTranslation()(
  connect(mapStateToProps)(withStyles(styles, { injectTheme: true })(BulkDeleteConsignmentModal)),
);
